import { useEffect, useState } from "react";
import AskAddyV2 from "../../models/askAddyV2";
import { FEATURED_APP_GROUPS } from "./featuredApps";

/**
 * Each section's apps from Composio's catalog (its `categories`, most used first), by section id, so a
 * section fills up to its preview and See all lists the whole category after ours. A section stays
 * empty when its load fails, or when the agent doesn't know categories yet (it doesn't echo them back):
 * our own picks still show.
 */
const useCategoryApps = (identity, isEnabled) => {
  const [appsBySection, setAppsBySection] = useState({});
  const [loadingIds, setLoadingIds] = useState(() => new Set(FEATURED_APP_GROUPS.map(({ id }) => id)));

  useEffect(() => {
    if (!isEnabled) {
      setLoadingIds(new Set());

      return undefined;
    }

    let isCancelled = false;
    FEATURED_APP_GROUPS.forEach(({ id, categories }) => {
      AskAddyV2.integrations
        .list({ categories }, identity)
        .then((page) => {
          if (!isCancelled && Array.isArray(page?.categories)) {
            setAppsBySection((current) => ({ ...current, [id]: page.apps || [] }));
          }
        })
        // The section keeps our own picks; See all says nothing more is listed.
        .catch(() => undefined)
        .finally(() => {
          if (!isCancelled) {
            setLoadingIds((current) => new Set([...current].filter((loadingId) => loadingId !== id)));
          }
        });
    });

    return () => {
      isCancelled = true;
    };
  }, [identity, isEnabled]);

  return { appsBySection, loadingIds };
};

export default useCategoryApps;
